import ReactSignatureCanvasImport from "react-signature-canvas";

// With Vite 8 ESM exports of packages are required, signature-canvas is not updated yet so we juggle the types to get the default export
type ReactSignatureCanvasType = typeof ReactSignatureCanvasImport;
const MaybeDefaultCanvas = ReactSignatureCanvasImport as
  | (ReactSignatureCanvasType & { default: never })
  | { default: ReactSignatureCanvasType };
const ReactSignatureCanvas = MaybeDefaultCanvas.default
  ? MaybeDefaultCanvas.default
  : (MaybeDefaultCanvas as ReactSignatureCanvasType);

import { styled } from "simplydo/react/styled";
import { Segment } from "simplydo/react/ui/segment";

const CanvasContainer = styled(Segment)`
  margin: 0;
  background-color: #fff;
  padding: 0px !important;
`;

const ClearText = styled.span`
  color: gray;
  text-decoration-line: underline;
  margin: 5px 0;
  display: block;
  cursor: pointer;
`;

type SignatureCanvasProps = {
  canvasRef: React.RefObject<ReactSignatureCanvasImport | null>;
  width?: string;
  height?: string;
};

const SignatureCanvas = ({
  canvasRef,
  width = "100%",
  height = "30px",
}: SignatureCanvasProps) => {
  return (
    <div>
      <CanvasContainer style={{ width, height }}>
        <ReactSignatureCanvas ref={canvasRef} canvasProps={{ width, height }} />
      </CanvasContainer>
      <ClearText onClick={() => canvasRef.current?.clear()}>
        Clear signature
      </ClearText>
    </div>
  );
};

export default SignatureCanvas;
